import { fromApiBoolean } from '@liquidweb-dev/club-sauce/types/boolean';
import useAssetDetails from 'modules/queries/asset/useDetails';

const useAddOns = (uniqId: string) => {
	const { data: assetDetailsData, ...rest } = useAssetDetails(
		{
			uniq_id: uniqId,
			alsowith: ['capabilities', 'associationDetails', 'featureDetails'],
		},
		{
			refetchInterval: 30000,
		},
	);

	const {
		associationDetails,
		capabilities,
		featureDetails,
		controlPanel,
		isWindows,
	} = assetDetailsData || {};

	const threatDown = associationDetails?.find(
		(association) => association.type === 'ServerSecurity.ThreatDown',
	);
	const imunify360 = associationDetails?.find(
		(association) => association.type === 'ServerSecurity.Imunify360',
	);
	const corero = associationDetails?.find(
		(association) => association.type === 'DDoS.Server.Protect',
	);
	const serverSecurePlus = associationDetails?.find(
		(association) => association.type === 'ServerSecurePlus',
	);
	const vulnerabilityAssess = associationDetails?.find(
		(association) => association.type === 'Vulnerability.Assess',
	);
	const mssql = featureDetails?.MsSQL;

	const eset = featureDetails?.WinAV?.value === 'NOD32';

	const coreroUniqId = corero?.other_uniq_id;
	const imunify360UniqId = imunify360?.other_uniq_id;
	const threatDownUniqId = threatDown?.other_uniq_id;
	const serverSecurePlusUniqId = serverSecurePlus?.other_uniq_id;
	const vulnerabilityAssessUniqId = vulnerabilityAssess?.other_uniq_id;
	const mssqlUniqId = mssql?.id;

	const canAddCorero =
		fromApiBoolean(capabilities?.canDDoSServerProtect) && !coreroUniqId;
	const canAddImunify360 =
		fromApiBoolean(capabilities?.canImunify360) && !imunify360UniqId;
	const canAddThreatDown =
		fromApiBoolean(capabilities?.canThreatDown) && !threatDownUniqId;

	const canShowImunify360Upsell =
		canAddImunify360 && !isWindows && controlPanel;
	const canShowThreatDownUpsell =
		canAddThreatDown && !isWindows && !controlPanel;

	const hasInstalledAddOns = Boolean(
		threatDownUniqId ||
			imunify360UniqId ||
			coreroUniqId ||
			mssqlUniqId ||
			serverSecurePlusUniqId ||
			vulnerabilityAssessUniqId ||
			eset,
	);
	const canInstallAddOns = canAddCorero || canAddImunify360 || canAddThreatDown;

	return {
		canAddCorero,
		canAddImunify360,
		canAddThreatDown,
		canShowImunify360Upsell,
		canShowThreatDownUpsell,
		corero,
		serverSecurePlus,
		vulnerabilityAssess,
		mssql,
		eset,
		hasInstalledAddOns,
		imunify360,
		threatDown,
		canInstallAddOns,
		regionId: assetDetailsData?.region_id,
		...rest,
	};
};

export default useAddOns;
